import { Dispatch } from "redux"
import { UtilityService } from "Shared/services"

export const sendBugReport = (data: { email: string; message: string }) => (dispatch: Dispatch) => UtilityService.sendBugReport(data)
